<template>
  <Modal id="LeaveTypeDetail" width="60%" :visible="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('leaveType.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
      <DescriptionsItem :label="$t('leaveType.field.id_lea_typ')">{{data.idLeaTyp}}</DescriptionsItem>
      <DescriptionsItem :label="$t('leaveType.field.leave_type_name')">{{data.leaveTypeName}}</DescriptionsItem>
      <DescriptionsItem :label="$t('leaveType.field.payroll_required')">{{selectList.booleanList.find(item=>item.value===data.payrollRequired).label}}</DescriptionsItem>
      <DescriptionsItem :label="$t('leaveType.field.leave_type_name_en')">{{data.leaveTypeNameEn}}</DescriptionsItem>
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "LeaveTypeDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      selectList:{
        booleanList:[{value: 0,label: '否'},{value: 1,label: '是'}],
      },
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>